export default "__VITE_ASSET__B1L8Iff3__"